// Rotating QR helpers — mirrors apps/wallet/wallet_service.py's per-ticket
// seed-token scheme so the website generates the exact token the scanner
// verifies. Only active for tickets that carry `rotation_seed` (the backend
// only sends it while the admin QR-rotation toggle is ON).

const hexFromBuffer = (buf) =>
  [...new Uint8Array(buf)].map((b) => b.toString(16).padStart(2, '0')).join('');

export const DEFAULT_ROTATION_WINDOW_SECONDS = 300;

export function getRotationWindowSeconds(ticket) {
  const value = Number(ticket?.rotation_window);
  return Number.isFinite(value) && value >= 30 && value <= 3600
    ? value
    : DEFAULT_ROTATION_WINDOW_SECONDS;
}

export async function computeRotatingToken(seed, ticketCode, windowSeconds, atMs = Date.now()) {
  const windowIndex = Math.floor(atMs / 1000 / windowSeconds);
  const msg = `${seed}:${String(ticketCode || '').trim().toUpperCase()}:${windowIndex}`;
  const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(msg));
  return hexFromBuffer(digest).slice(0, 20);
}

export function buildScanLink(ticketCode, origin) {
  const base = origin || window.location.origin;
  return `${base}/scan?code=${encodeURIComponent(ticketCode || '')}`;
}

export async function buildRotatingScanLink(ticket, origin, atMs) {
  const base = buildScanLink(ticket?.ticket_code, origin);
  if (!ticket?.rotation_seed) return base;
  const token = await computeRotatingToken(
    ticket.rotation_seed,
    ticket.ticket_code,
    getRotationWindowSeconds(ticket),
    atMs,
  );
  return `${base}&t=${token}`;
}
